import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { IndicatorFilters } from 'models/requestBody/getBlockOutputsParameters.interface';
import { indicatorFilterChange, overallIndicatorFilter, setEmptyData } from 'redux/PlanPageSlice';

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface Properties {
  indicatorFilter: string;
  filterChange: (value: IndicatorFilters) => void;
}

const KpiFilter = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const [isSmallLaptop] = useMediaQuery('(max-width: 1415px)');
  const filter = useSelector(overallIndicatorFilter);
  const [isVerySmallMobile] = useMediaQuery('(max-width: 350px)');
  const handleChange = (value: IndicatorFilters) => {
    if (filter !== value) {
      dispatch(setEmptyData(true));
      dispatch(indicatorFilterChange(value));
    }
  };

  const getDisplayLevels = () => {
    switch (filter) {
      case 'outputs':
        return 'Output Indicators only';

      default:
        return 'All Input and Output Indicators';
    }
  };
  return (
    <Menu>
      <MenuButton
        height={isMobile ? '25px' : '30px'}
        paddingRight={isVerySmallMobile ? '2' : '2'}
        paddingLeft={isVerySmallMobile ? '2' : '4'}
        as={Button}
        rightIcon={<ChevronDownIcon fontSize={'sm'} />}
        width='fit-content'
        textTransform='none'
        fontWeight='400'
        fontSize={isMobile ? 'xs' : 'sm'}
        color={'white'}
        border='none'
        bg='transaparant'
        boxShadow='none'
      >
        <Text fontSize={isSmallLaptop ? '2xs' : 'xs'} fontWeight='normal'>
          {getDisplayLevels()}
        </Text>
      </MenuButton>
      <MenuList zIndex={'dropdown'} maxW='fit-content' borderRadius={'10px'}>
        <MenuOptionGroup type='radio' value={filter}>
          <MenuItemOption
            minH='30px'
            value='outputs'
            onClick={() => handleChange('outputs')}
            aria-checked={filter === 'Q'}
            data-testid='filter-KPI-test'
          >
            <Text
              fontFamily='regular_roboto'
              fontSize={isMobile ? '2xs' : 'xs'}
              textAlign={'start'}
            >
              Output Indicators only
            </Text>
          </MenuItemOption>
          <MenuItemOption
            minH='30px'
            value='inputs_and_outputs'
            onClick={() => handleChange('inputs_and_outputs')}
            data-testid='All-Indicators-dropdown-test'
          >
            <Text
              fontFamily='regular_roboto'
              fontSize={isMobile ? '2xs' : 'xs'}
              textAlign={'start'}
            >
              All Input and Output Indicators
            </Text>
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};

export default KpiFilter;
